import React from 'react';

const Facebook = () => {
  return (
    <div className="flex items-center justify-center w-16 h-16 bg-white rounded-full shadow-lg">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="w-8 h-8 text-orange-500"
        viewBox="0 0 24 24"
        fill="currentColor"
      >
        <path d="M22.675 0h-21.35C.6 0 0 .6 0 1.326v21.348C0 23.4.6 24 1.325 24H12.81v-9.294H9.692V10.41h3.118V7.797c0-3.1 1.894-4.788 4.66-4.788 1.325 0 2.464.099 2.795.143v3.243l-1.917.001c-1.504 0-1.794.714-1.794 1.76v2.31h3.587l-.467 3.296h-3.12V24h6.116c.725 0 1.325-.6 1.325-1.326V1.326C24 .6 23.4 0 22.675 0z" />
      </svg>
    </div>
  );
};

export default Facebook;
